import React, { useEffect, useRef, useCallback } from 'react';
import {
    Box,
    Paper,
    Typography,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import softhouseLogo from 'assets/images/softhouseLogo.png';
import { CHATBOT_ASK_URL, EMPLOYEE_CHATBOT_ASK_URL } from 'api/chatbot';
import useChatbotSession from 'hooks/useChatbotSession';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import PropTypes from 'prop-types';
import { theme } from 'utils/theme';
import { hasPermissions, isAdmin } from 'utils/auth';
import { EMPLOYEE_MANUAL_ASK } from 'api/employeeManual';

const Chatbot = ({ open, onClose }) => {
    const messagesEndRef = useRef(null);

    const roles = hasPermissions() || [];
    const chatbotUrl = isAdmin()
        ? CHATBOT_ASK_URL
        : roles.includes('Employee')
            ? EMPLOYEE_CHATBOT_ASK_URL
            : EMPLOYEE_MANUAL_ASK;

    const dataChat = useChatbotSession(
        chatbotUrl,
        'Hello! How can I help you with your data today?'
    );

    const { messages, sendMessage, loading } = dataChat;

    const handleSend = useCallback(
        async (message) => {
            await sendMessage(message);
        },
        [sendMessage]
    );

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages, open]);

    if (!open) {
        return null;
    }

    return (
        <Paper
            elevation={8}
            sx={{
                position: 'fixed',
                bottom: 150,
                right: 24,
                width: 380,
                height: 550,
                display: 'flex',
                flexDirection: 'column',
                zIndex: 1300,
                borderRadius: 2,
                overflow: 'hidden',
                backgroundColor: theme.palette.grey[100],
            }}
        >
            <Box
                sx={{
                    p: '14px',
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <img src={softhouseLogo} alt="Logo" style={{ width: 34, height: 34 }} />
                    <Typography variant="h6" sx={{ marginLeft: '8px' }}>
                        Softhouser
                    </Typography>
                </Box>
                <IconButton
                    size="small"
                    onClick={onClose}
                    sx={{ color: 'primary.contrastText' }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            <ChatMessages
                messages={messages}
                isLoading={loading}
                endRef={messagesEndRef}
            />
            <ChatInput
                onSend={handleSend}
                disabled={loading}
            />
        </Paper>
    );
};

Chatbot.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func
};

export default Chatbot;
